/**
 * Registers the N71 service worker (public/sw.js).
 *
 * The SW makes the app installable as a PWA and gives an installed app a
 * fast, offline-resilient launch. It is registered in production only —
 * in dev a SW would sit in front of Vite's HMR and serve stale modules.
 */
export function registerServiceWorker(): void {
  // Vite injects import.meta.env.PROD; dev keeps HMR clean.
  if (!import.meta.env.PROD) return;
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      // Non-fatal — the app works fine without the SW, it just isn't
      // installable / offline-resilient.
      console.warn("[pwa] service worker registration failed:", err);
    });
  });
}
